import React, { useEffect, Suspense, useState } from 'react';
import './../style/css/app.css';
import { Navigation } from './Navigation/Navigation';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from '../models/provider';
import Meta from 'react-meta-tags';
// import LogoHeart from './../assets/images/logo/logo_heart.svg';
import Loader from './Shared/Loader';

const Imprint = React.lazy(() => import('./Imprint/Imprint'));
const DataProtection = React.lazy(() => import('./DataProtection/DataProtection'));

interface Props {

}

export const App = (props: Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        Provider.saveVisit();
    }, []);

    const setLoading = (isLoading: boolean): void => {
        setIsLoading(isLoading);
    };

    return (
        <div id="app">
            <Meta>
                <title>Fliesen Semlitsch GmbH</title>
                <meta name="theme-color" content="#141414"></meta>
                <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
                <meta name="description" content="Fliesen Semlitsch GmbH" />
                <meta name="lang" content="de" />
                {/* <link rel="shortcut icon" href='/images/logo_heart.svg' type="image/x-icon" /> */}
            </Meta>
            <h1 style={{ display: 'none' }}>Fliesen Semlitsch</h1>
            <Loader isLoading={isLoading} />
            <Router>
                <Navigation />
                <div id="content">
                    <Suspense fallback={ (<></>) }>
                        <Switch>
                            {
                                Provider.navigationEntries.map(entry => {
                                    return (
                                        <Route path={entry.route}
                                            key={entry.id}
                                            exact={true}>
                                            <entry.component changeLoadingState={setLoading} />
                                        </Route>
                                    )
                                })
                            }
                            <Route path="/imprint"
                                exact={true}>
                                <Imprint changeLoadingState={setLoading} />
                            </Route>
                            <Route path="/data-protection"
                                exact={true}>
                                <DataProtection changeLoadingState={setLoading} />
                            </Route>
                        </Switch>
                    </Suspense>
                </div>
            </Router>
        </div>
    )
};